import React from "react";
import axios from "axios";
import './Contact.css'; 
import Footer from './Footer';

const Contact = () => {
  const formId = "7028";

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);
  };

  return (
    <div className="contact-page">
      <h1>Contact Us</h1>
      <p className="contact-description">We’d love to hear from you. Please fill out the form below, and we’ll get back to you shortly.</p>
      <div className="contact-container">
        <form className="contact-form" onSubmit={handleSubmit}>
          <label className="form-label">
            Your Name
            <input
              type="text"
              name="your-name"
              autoComplete="name"
              required
              className="form-input"
            />
          </label>
          <label className="form-label">
            Your Email
            <input
              type="email"
              name="your-email"
              autoComplete="email"
              required
              className="form-input"
            />
          </label>
          <label className="form-label">
            Subject
            <input
              type="text"
              name="your-subject"
              required
              className="form-input"
            />
          </label>
          <label className="form-label">
            Your Message
            <textarea
              name="your-message"
              className="form-textarea"
              placeholder="Type your message here..."
            />
          </label>
          <button type="submit" className="form-submit-button">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default Contact;
